import { ChatMessageContentType } from '@indigohive/cogfy-types'
import { GetChatMessageFilesResultData } from '@indigohive/cogfy-types/endpoints/getChatMessagesPage'
import { ClassValue } from 'clsx'
import { createElement } from 'react'
import { WhatsAppContentContacts } from './WhatsAppContentContacts'
import { WhatsAppContentLocation } from './WhatsAppContentLocation'
import { WhatsAppContentText } from './WhatsAppContentText'
import { WhatsAppcontentInteractive } from './WhatsAppContentInteractive'
import { WhatsAppContentTemplate } from './WhatsAppContentTemplate'
import { ChatMessageContentAudio } from './ChatMessageContentAudio'
import { ChatMessageContentDocument } from './ChatMessageContentDocument'
import { ChatMessageContentImage } from './ChatMessageContentImage'

type WhatsAppContentComponentType = typeof WhatsAppContentText

const WHATSAPP_CONTENT_BY_TYPE: Partial<Record<ChatMessageContentType, WhatsAppContentComponentType>> = {
  audio: ChatMessageContentAudio,
  button: WhatsAppContentText,
  document: ChatMessageContentDocument,
  image: ChatMessageContentImage,
  contacts: WhatsAppContentContacts,
  interactive: WhatsAppcontentInteractive,
  location: WhatsAppContentLocation,
  template: WhatsAppContentTemplate,
  text: WhatsAppContentText
}

export type WhatsAppContentProps = {
  className?: ClassValue
  content: string | null
  contentType: ChatMessageContentType | null
  contentData: any
  files: GetChatMessageFilesResultData[]
  fromAuthenticatedUser: boolean
}

export function WhatsAppContent (props: WhatsAppContentProps) {
  const { contentType } = props

  const whatsAppContentComponent = contentType
    ? WHATSAPP_CONTENT_BY_TYPE[contentType]
    : null

  return (
    <>
      {whatsAppContentComponent && createElement(whatsAppContentComponent, props)}
    </>
  )
}
